import { PartialStateStore } from '../../../../core/types/application-state';
import { DataLoader } from '../../../../core/types/data-loader';
import { getMutualFundBlankForm } from '../../../shared/services/mutualfund-transfer-form-service';
import { createFormURL } from '../../../shared/utils';

export const loadMutualFundTransferForm: DataLoader = async ({
  store
}): Promise<PartialStateStore> => {
  // call form endpoint by posting application data and retreiving blob response
  const mutualfundFormBlob = await getMutualFundBlankForm();

  // create data url here for form and store that into temp data
  // must be url, blob object will not be passed/stored correctly
  const mutualFundFormURL = createFormURL(mutualfundFormBlob);
  // add form url to existing temp data, as to not overwrite analytic data
  const loadedData = { ...store.loadedData, mutualFundFormURL };
  return { loadedData };
};
